module.exports = __webpack_public_path__ + "static/media/flow-desktop.2864b5d7.png";